import * as React from 'react';
import Button from '@narvar/nth-block-button';
import { MediumHeader } from '@narvar/nth-bit-header';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';
import {
  useRedirectToHoldContext,
  UI_STATE,
} from '../../../hooks/useRedirectToHoldState';
import CustomComponentContext from '../../CustomComponentContext';

interface Props {
  featureName: string;
}

const InitialPanel: React.FunctionComponent<Props> = ({
  featureName,
}: Props) => {
  const { track } = React.useContext(CustomComponentContext);

  const { state: rthState, update: updateRthState } =
    useRedirectToHoldContext();

  const { redirectToHoldCta, redirectToHoldRedirectPackage } =
    useTranslations();

  const logRedirectToHoldEvent = () => {
    track({
      eventType: 'click',
      clickSubType: 'submit_success',
    });
  };

  React.useEffect(() => {
    track({ eventType: 'component_render' });
  }, []);

  return (
    <div style={{ padding: '0.5rem 0 0 0' }}>
      <MediumHeader
        as="h2"
        featureName={featureName}
        containerCustomStyle={{ margin: '0 0 1rem 0' }}
      >
        {redirectToHoldCta}
      </MediumHeader>
      <Button
        onClick={() => {
          logRedirectToHoldEvent();

          updateRthState({
            ...rthState,
            uiState: UI_STATE.VERIFY_ADDRESS,
          });
        }}
      >
        {redirectToHoldRedirectPackage}
      </Button>
    </div>
  );
};

export default withTranslationsProvider(InitialPanel, {
  translationKeys: ['redirectToHoldCta', 'redirectToHoldRedirectPackage'],
});
